import { motion, useAnimation } from 'framer-motion'
import SVGJSContainer, { pathDraw } from '../../../utils/SVGJSContainer'
import NumberAnimate from '../../NumberAnimate'

function DesFemmes2(isVisible) {
	const controls = useAnimation()

	return (
		<SVGJSContainer controls={controls}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="671.18"
				height="671.18"
				viewBox="0 0 671.18 671.18"
			>
				<g data-name="Groupe 2552" transform="translate(-243.221 -1449.32)">
					<text
						data-name="Make sure that the s"
						fontFamily="AcuminPro-Regular, Acumin Pro"
						fontSize="35"
						transform="translate(359.956 1764.265)"
					>
						<tspan x="110.729" y="26">
							Note obtenue{' '}
						</tspan>
						<tspan x="15.794" y="71">
							par Elogie-Siemp à l&apos;index{' '}
						</tspan>
						<tspan x="73.781" y="115">
							Femmes/Hommes
						</tspan>
						<tspan x="150.781" y="159">
							(en 2024)
						</tspan>
					</text>
					<text
						fill="#e53a39"
						data-name="98/100"
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontSize="80"
						fontWeight="700"
						transform="translate(447.706 1727.5)"
					>
						<tspan x="0" y="0">
							<NumberAnimate
								tspan
								suffix="/100"
								nb={98}
								duration={2.5}
								delay={0.5}
							/>
						</tspan>
					</text>
					<g fill="none" data-name="Tracé 30382">
						<path
							d="M335.59 0c185.341 0 335.59 150.249 335.59 335.59S520.931 671.18 335.59 671.18 0 520.931 0 335.59 150.249 0 335.59 0z"
							transform="translate(243.221 1449.32)"
						></path>
						<path
							fill="#ffc3d7"
							d="M335.59 80C194.657 80 80 194.657 80 335.59s114.657 255.59 255.59 255.59 255.59-114.657 255.59-255.59S476.523 80 335.59 80m0-80C520.93 0 671.18 150.249 671.18 335.59c0 185.341-150.249 335.59-335.59 335.59C150.249 671.18 0 520.93 0 335.59 0 150.249 150.249 0 335.59 0z"
							transform="translate(243.221 1449.32)"
						></path>
					</g>
					<motion.path
						fill="none"
						stroke="#e53a39"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeMiterlimit="10"
						strokeWidth="35"
						d="M578.908 1473.464c172.1 0 311.619 139.517 311.619 311.619s-139.517 311.619-311.619 311.619-311.619-139.518-311.619-311.62c0-150.591 106.817-276.231 248.817-305.289"
						data-name="Tracé 30383"
						variants={pathDraw}
						initial="hidden"
						animate={controls}
					></motion.path>
				</g>
			</svg>
		</SVGJSContainer>
	)
}

export default DesFemmes2
